import * as Yup from "yup";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { CMSTag } from "../../../../../models/CMS/cmsTag";
import { Form, Formik } from "formik";
import { DetailPageHeader } from "../../../ui-components/pageLayout/DetailPageHeader";
import { store } from "../../../store";
import {
  ClearTagAction,
  DeleteTagAction,
  GetTagAction,
  getTagSelector,
  getTagsSelector,
  SetTagAction,
  UpdateTagAction,
} from "../../../store/reducers/cmsReducer";
import LocalizedImagesAccordion from "../SharedAccordions/LocalizedImagesAccordion";
import TagsBasicInformationAccordion from "./accordions/TagsBasicInformationAccordion";

const UpdateTagSchema = Yup.object().shape({
  name: Yup.string()
    .min(2, "Too Short!")
    .max(50, "Too Long!")
    .required("Required*"),
});

export const Tag: React.FC = () => {
  const tags = useSelector(getTagsSelector);
  const tag = useSelector(getTagSelector);
  const [isDeleting, setIsDeleting] = useState<boolean>(false);
  const history = useNavigate();
  const params = useParams();

  useEffect(() => {
    if (!tag && !isDeleting) {
      const foundTag = tags?.find((tag) => tag.tagId == params.id);
      if (foundTag) {
        store.dispatch(SetTagAction(foundTag.serialize()));
      } else {
        if (params.id) {
          store.dispatch(GetTagAction(params.id));
        } else {
          console.error("Tag ID is missing.");
        }
      }
    } else if (!tag && isDeleting) {
      redirect();
    }
  }, [tag, tags]);

  useEffect(() => {
    return () => {
      store.dispatch(ClearTagAction());
    };
  }, []);

  const submitUpdateTag = (values: CMSTag) => {
    store.dispatch(UpdateTagAction(values.serialize()));
  };

  const submitDeleteTag = () => {
    setIsDeleting(true);
    if (params.id) {
      store.dispatch(DeleteTagAction(params.id));
    } else {
      console.error("Tag ID is missing.");
    }
  };

  const redirect = () => {
    history("/admin/metadata/tags");
  };

  return (
    <>
      {tag && (
        <>
          <Formik
            initialValues={tag}
            validationSchema={UpdateTagSchema}
            onSubmit={(values: CMSTag) => {
              submitUpdateTag(values);
            }}
          >
            {({ handleSubmit, setFieldValue }) => (
              <Form>
                <DetailPageHeader
                  title="Tag Metadata"
                  entity={tag}
                  onDelete={submitDeleteTag}
                  onBack={redirect}
                />
                <TagsBasicInformationAccordion />
                <LocalizedImagesAccordion
                  defaultExpanded={true}
                  setFieldValue={setFieldValue}
                  assetId={tag.tagId}
                />
              </Form>
            )}
          </Formik>
        </>
      )}
    </>
  );
};
